import { baseApi } from 'src/store/APIs'

import { changePassword, me } from './actions'

export const miscApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    changePassword: changePassword(builder),
    me: me(builder),
  }),
})

export const {
  useMeQuery,
  useChangePasswordMutation,
  reducer: miscApiReducer,
  reducerPath: miscApiReducerPath,
} = miscApi
